import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxios, createAxiosWithToken } from "./createAxios";

export async function GetAll(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDCenters/GetAll?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)
}

export async function GetByCity(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDCenters/GetByCity?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&CityId=" + param.CityId)
}

export async function GetByCityWithActiveCenter(param) {
    return await createAxios().get("/OPDCenters/GetByCityWithActiveCenter?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&CityId=" + param.CityId)
}

export async function GetRandomActiveCenter(params) {
    return await createAxios().get(
        "/ApplicationUser/GetRandomActiveCenter?Count=" + params.count
    );

}
export async function GetByCityWithActiveCenterAndSpecialization(param) {
    return await createAxios().get("/OPDCenters/GetByCityWithActiveCenterAndSpecialization?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&CityId=" + param.CityId + "&SpecializationId=" + param.SpecializationId)
}

export async function GetByActiveCenterWithSpecialization(param) {
    return await createAxios().get("/OPDCenters/GetByActiveCenterWithSpecialization?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&CityId=" + param.CityId + "&SpecializationId=" + param.SpecializationId)
}

export async function GetAllByUser() {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDCenters/GetAllByUser")
}

export async function GetAllByUserPublic(param) {
    return await createAxios().get("/OPDCenters/GetAllByUserPublic?DoctorId=" + param.DoctorId)
}

export async function GetById(id) {
    return await createAxios().get("/OPDCenters/GetById?Id=" + id)
}

export async function Add(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDCenters/Add", param)
}

export async function Edit(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDCenters/Edit", param)
}

export async function DoctorChangeStatus(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("OPDCenters/DoctorChangeStatus?Status=" + param.Status + "&Id=" + param.Id)
}

export async function Remove(id) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDCenters/Remove?Id" + id)
}

